/* global axios */
import ApiClient from './ApiClient';

class PatientProfilesAPI extends ApiClient {
  constructor() {
    super('patient_profiles', { accountScoped: true, apiVersion: 'v2' });
  }

  list({
    phase,
    procedureId,
    physicianId,
    contactId,
    q,
    page = 1,
    perPage = 50,
  } = {}) {
    const params = new URLSearchParams();
    if (phase) params.append('phase', phase);
    if (procedureId) params.append('procedure_id', procedureId);
    if (physicianId) params.append('physician_id', physicianId);
    if (contactId) params.append('contact_id', contactId);
    if (q) params.append('q', q);
    params.append('page', page);
    params.append('per_page', perPage);
    return axios.get(`${this.url}?${params.toString()}`);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new PatientProfilesAPI();
